import { TeamTypes } from '@cbinsights/adminservice/adminservice';
import { UseQueryResult, useQuery } from 'react-query';
import { GetTeamTypes } from '.';
import { getTeamTypes } from '../api/GetTeamTypes';

type Return = TeamTypes;

export const useGetTeamTypes = ({
  enabled = false,
}: {
  enabled: boolean;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetTeamTypes]>(
    ['GetTeamTypes'],
    () => getTeamTypes(),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      cacheTime: 1200000, // 20 minutes in milliseconds
    }
  );
